import { useState, useEffect } from 'react';
import every from 'lodash/every';
import find from 'lodash/find';
import findKey from 'lodash/findKey';
import { utcToZonedTime } from 'date-fns-tz';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { useStore } from './useStore';
import useHttp from './useHttp';
import useAvailability from './useAvailability';
import getApiToken from '../utils/getApiToken';
import usePrice from './usePrice';
// import Ticket from '../utils/tickets';

const apiToken = getApiToken();

const useBackendSync = () => {
  const [state, dispatch] = useStore();
  const { sendRequest } = useHttp();
  const { appData, clientState } = state;
  const { checkParking } = useAvailability();

  const postUpdate = (s) => {
    // console.log('postUpdate', s);
    if (s) {
      dispatch('SET', {
        clientState: s
      });
    }
    const obj = {
      '_t': apiToken,
      'state': s ? s : clientState
    };
    sendRequest({
      url: '/wp-json/wbst-booking/v1/update',
      params: obj
    });
  }

  const runResume = (catid, s) => {
    const id = catid ? catid : appData.ticket_types[s]['category_id'];
    const obj = {
      '_t': apiToken,
      'id': id //clientState.cat
    };
    sendRequest({
      url: '/wp-json/wbst-booking/v1/resume',
      params: obj
    }, processResume);
  }

  const processResume = (data) => {
    const section = sessionStorage.getItem('section');
    // console.log('processResume clientState', data.value);
    // console.log('processResume section', section);
    const thisFares = data.value.eventTypes[0]['fares'];
    const thisAddons = data.value.eventTypes[0]['addons'];
    // console.log('thisFares', thisFares);
    let prices = [
      ...thisFares,
      ...thisAddons
    ];
    prices.map(t => {
      t.price = parseFloat(t.price);
      t.retailPrice = parseFloat(t.retailPrice);
      return t;
    })
    // console.log('prices', prices);
    dispatch('SET', {
      fares: prices,
    });

    let cS = data.value.clientState;
    if (cS.evid) {
      // console.log('has evid');
      const rID = cS.evid.split('-');
      // console.log('rID[0]', rID[0]);
      const prevSection = findKey(appData.ticket_types, { 'rid': rID[0] });
      // console.log('prevSection', prevSection);
      if (prevSection !== section) return false;

      postUpdate(cS);
      dispatch('SET', {
        dateTimeConfirmed: true,
        buttonDisabled: false
      });
      // console.log('has evid');
      // console.log('section', section);
      // console.log(section === 'studio-tour');
      dispatch('SET', {
        step: !!(cS.delivery.email && hasAddons) ? 3 : 2,
        stepped: !!(cS.delivery.email && hasAddons) ? 3 : 2,
        buttonDisabled: false,
        timerActive: true,
        firstName: cS.delivery.firstName,
        lastName: cS.delivery.lastName,
        email: cS.delivery.email,
        phone: cS.delivery.phone,
        affiliate: cS.delivery.affiliate,
        deliveryAddress1: cS.delivery.address1,
        deliveryAddress2: cS.delivery.address2,
        deliveryCity: cS.delivery.city,
        deliveryState: cS.delivery.state,
        deliveryPostal: cS.delivery.postal,
        deliveryCountry: cS.delivery.country,
        address1: cS.billing.billingAddress1,
        address2: cS.billing.billingAddress2,
        city: cS.billing.billingCity,
        geostate: cS.billing.billingState,
        postal: cS.billing.billingPostal,
        country: cS.billing.billingCountry,
        dateContext: utcToZonedTime(cS.evtime, 'UTC'),
        selectedDate: format(parseISO(cS.evtime), 'yyyy-MM-dd'),
        selectedDateTime: cS.evtime,
        selectedTime: format(parseISO(cS.evtime), 'HH:mm'),
        selectedEvent: cS.evid,
        dateTimeConfirmed: true
      });
      if (section === 'studio-tour') checkParking();
    }
  }

  return {
    postUpdate,
    runResume
  };
}

export default useBackendSync;